import {TextField} from '@hconnect/common/components'
import {CardBox} from '@hconnect/uikit/src/lib2'
import {Stack} from '@mui/material'
import {useFormContext} from 'react-hook-form'

import {
  ChecklistStepSection,
  UserSearchAutocompleteField,
  YesNoWithCommentField
} from '../../components'
import {HROC_CHECKLIST_FORM_WIDTH_IN_PX} from '../../consts'
import {useChecklistFormMeta, useWidgetTranslation} from '../../hooks'
import type {TakeFiveSafetyStepFormValues} from '../../types'
import {StepFormActionsContainer} from '../StepFormActionsContainer'

type Props = {
  readOnly?: boolean
}

export const ChecklistStepFormFields = ({readOnly = false}: Props) => {
  const {control} = useFormContext<TakeFiveSafetyStepFormValues>()
  const {t} = useWidgetTranslation()
  const {plantId} = useChecklistFormMeta()

  return (
    <CardBox width={{xs: '100%', md: HROC_CHECKLIST_FORM_WIDTH_IN_PX}}>
      <Stack spacing={2}>
        <ChecklistStepSection title={t('takeFive.label.safetyChecklist')}>
          <YesNoWithCommentField
            label={t('takeFive.label.peopleInformed')}
            name="peopleInformed"
            control={control}
            readOnly={readOnly}
          />
          <YesNoWithCommentField
            label={t('takeFive.label.rightTools')}
            name="rightTools"
            control={control}
            readOnly={readOnly}
          />
          <YesNoWithCommentField
            label={t('takeFive.label.fitForDuty')}
            name="fitForDuty"
            control={control}
            readOnly={readOnly}
          />
          <YesNoWithCommentField
            label={t('takeFive.label.riskRecognized')}
            name="riskRecognized"
            control={control}
            readOnly={readOnly}
          />
        </ChecklistStepSection>
        <ChecklistStepSection title={t('takeFive.label.reasonToWorkSafe')}>
          <TextField
            name="reasonToWorkSafe"
            label={t('label.yourAnswer')}
            optional
            control={control}
            readOnly={readOnly}
          />
        </ChecklistStepSection>
        <ChecklistStepSection title={t('takeFive.label.supervisor')}>
          <UserSearchAutocompleteField
            plantId={plantId}
            name="supervisor"
            label={t('takeFive.label.supervisor')}
            control={control}
            readOnly={readOnly}
          />
        </ChecklistStepSection>
        <StepFormActionsContainer />
      </Stack>
    </CardBox>
  )
}
